import React, { FC } from 'react';
import { IconProps } from '.';

export const FolderIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    // this is a fix for color deviations in the nested folderlist
    // It should not happen but givent the complexity and !important styleoverrides
    // we cant debug it. This enforces some randomness to scope the linear gradient.
    const id = Math.random().toString();

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                stroke="currentColor"
                strokeWidth="1.5"
                d="m10.36 6.53.22.35H19c.82 0 1.36.28 1.7.64.36.37.55.9.55 1.48v8.8c0 .8-.65 1.45-1.47 1.45H4.22c-.82 0-1.47-.66-1.47-1.46V6.21c0-.8.65-1.46 1.47-1.46h3.9c.69 0 1 .15 1.24.37.28.25.5.6.88 1.2l.12.21Z"
            />
            <path
                stroke={`url(#${id})`}
                d="M6.3 9.83h13.09c.88 0 1.61.73 1.61 1.64v6.4c0 .9-.73 1.63-1.61 1.63H4.6c-.88 0-1.61-.73-1.61-1.63v-4.9c0-1.7 1.2-3.14 3.3-3.14Z"
            />
            <defs>
                <linearGradient id={id} x1="5.67" x2="19.39" y1="10.4" y2="10.4" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
